<script>
  import { onMount } from 'svelte';
  import { format } from 'svelte-i18n';

  import { getNotificationsContext } from '@client/components/notifications';

  import Pusher from '@client/pages/signatures/pusher/components/pusher.svelte';

  import { pusherStore } from '@client/stores/pusher';

  /**
   * Controls whether the next button in the workflow step is disabled.
   * @type {boolean}
   * @default true
   */
  export let nextDisabled = true;

  /**
   * Callback function invoked when the workflow step executes.
   * @type {Function | null}
   * @default null
   */
  export let onExecute = null;

  /**
   * Step configuration object containing step data and metadata.
   * @type {Object}
   * @default { data: {} }
   */
  export let step = { data: {} };

  const { addNotification } = getNotificationsContext();

  const notify = (text, type = 'success', autohide = 2500, position = 'top-right') => {
    addNotification({ text, type, autohide, position });
  };

  let pushed = false;
  let pusherConfig = {};
  let pushTo = null;
  let userCount = 0;

  const executePush = async () => {
    if (!pushed) {
      throw new Error($format('label.PUSH_NOT_COMPLETED'));
    }

    step.data = {
      id: pushTo || 'unknown',
      type: pusherConfig.mode?.value || 'signature'
    };

    notify($format('label.SUCCESS.PUSH_COMPLETED'));
    return { success: true };
  };

  onMount(() => {
    if (onExecute) {
      onExecute(executePush);
    }
  });

  // Track the push configuration
  $: if (pusherConfig.csvConfig?.sigdata?.data) {
    userCount = pusherConfig.csvConfig.sigdata.data.length;
  }

  $: nextDisabled = !pushed;
</script>

<div class="pusher-new-form">
  <Pusher bind:config={pusherConfig} bind:pushed bind:pushTo workflowMode={true} />
</div>

<style lang="scss">
  .pusher-new-form {
    // Styles inherited from pusher component
  }
</style>
